import 'apps/hiring/styles/components/survey-stats-sidebar.scss';
import React, { Fragment } from 'react';
import { resolve } from 'library/helpers/path-resolver';

class SurveyStatsChart extends React.Component {
  state = {
    paths: []
  }

  constructor(...params) {
    super(...params);
    this.ref = React.createRef();
  }

  static getDerivedStateFromProps(props) {
    const {
      invited,
      incomplete,
      started,
      complete
    } = props;

    const total = Math.max(invited + incomplete + started + complete, 1);
    const slices = [
      // invited is not accessable right now
      {percent: invited/total, label: 'invited', count: invited},
      {percent: incomplete/total, label: 'incomplete', count: incomplete},
      {percent: started/total, label: 'started', count: started},
      {percent: complete/total, label: 'complete', count: complete},
    ];

    const getCoordinatesForPercent = (percent) => (
      [Math.cos(2 * Math.PI * percent), Math.sin(2 * Math.PI * percent)]
    );

    let cumulativePercent = 0;

    return {
      paths: slices.map(({percent, ...slice}) => {
        // destructuring assignment sets the two variables at once
        const [startX, startY] = getCoordinatesForPercent(cumulativePercent);

        // each slice starts where the last slice ended, so keep a cumulative percent
        cumulativePercent += percent;

        const [endX, endY] = getCoordinatesForPercent(cumulativePercent);

        // if the slice is more than 50%, take the large arc (the long way around)
        const largeArcFlag = percent > .5 ? 1 : 0;

        // create an array and join it just for code readability
        const pathData = [
          `M ${startX} ${startY}`, // Move
          `A 1 1 0 ${largeArcFlag} 1 ${endX} ${endY}`, // Arc
          `L 0 0`, // Line
        ].join(' ');

        return {
          d: pathData,
          ...slice
        };
      })
    };
  }


  render() {
    return (
      <svg className="survey-stats-chart" ref={this.ref} viewBox="-1 -1 2 2" style={{transform: `rotate(-90deg)`}}>
        <defs>
          <mask id="survey-stats-chart-hole">
            <rect width="100%" height="100%" fill="white" style={{transform: 'translate(-50%,-50%)'}}/>
            <circle r="0.6" cx="0" cy="0" fill="rgba(0,0,0,.5)"/>
            <circle r="0.5" cx="0" cy="0" fill="black"/>
          </mask>
        </defs>
        {
          this.state.paths.map(({d,label})=>(
            <path key={label} d={d} mask="url(#survey-stats-chart-hole)"/>
          ))
        }
      </svg>
    );
  }
}

const SurveyStatsSidebar = ({ stats, employee }) => (
  <div className="hiring-sidebar">
    <h1>Pending Surveys</h1>
    <SurveyStatsChart
      invited={/*resolve(stats, 'invited', 0)*/ 0}
      incomplete={resolve(stats, 'incomplete', 0)}
      started={/*resolve(stats, 'ideal', 0) + resolve(stats, 'real', 0)*/ 0}
      complete={resolve(stats, 'complete', 0)}
    />
    <h1>Survey Stats</h1>
    {/*<div className="survey-stats-stat-auxilary-4">
      <strong>{ resolve(stats, 'invited', 0) }</strong> Invited without any response
    </div> */}
    <div className="survey-stats-stat-grey-3">
      {/*This is just a place holder for now*/}
      <strong>{ 0 }</strong> Not started
    </div>
    <div className={employee ? 'survey-stats-stat-auxilary-5':'survey-stats-stat-tertiary'}>
      <strong>{ resolve(stats, 'incomplete', null )}</strong> In Progress
    </div>
    <div className="survey-stats-stat-auxilary-2">
      <strong>{ resolve(stats, 'complete', 0)  }</strong> Completed
    </div>
  </div>
);


export default SurveyStatsSidebar;
